module.exports = __webpack_public_path__ + "static/media/ChaloMenu 1.c70d3662.jpg";